// src/pages/Legal/CookiesPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link } from '@mui/material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const CookiesPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Cookies Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: April 19, 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Typography variant="body1" paragraph>
          This Cookies Policy explains what cookies are, how we use them, and your choices regarding their use on the Rengigs platform.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>What are cookies?</Typography>
        <Typography variant="body1" paragraph>
          Cookies are small text files stored on your device (computer, tablet, mobile) when you visit websites. They help the website remember your actions and preferences over time.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>How we use cookies</Typography>
        <Typography variant="body1" paragraph>
          We use cookies for the following purposes:
        </Typography>
        <TableContainer component={Box} sx={{ mb: 3 }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: RENGIGS.light }}>
                <TableCell><strong>Type</strong></TableCell>
                <TableCell><strong>Purpose</strong></TableCell>
                <TableCell><strong>Duration</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Essential Cookies</TableCell>
                <TableCell>Necessary for the website to function (authentication, security, session management).</TableCell>
                <TableCell>Session / up to 1 year</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Preference Cookies</TableCell>
                <TableCell>Remember your settings (language, theme, filters).</TableCell>
                <TableCell>1 year</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Analytics Cookies</TableCell>
                <TableCell>Collect anonymous usage data to improve our platform (e.g., Google Analytics).</TableCell>
                <TableCell>Up to 2 years</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Marketing Cookies</TableCell>
                <TableCell>Used to deliver relevant advertisements and measure campaign effectiveness (only with your consent).</TableCell>
                <TableCell>Up to 2 years</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>Third‑Party Cookies</Typography>
        <Typography variant="body1" paragraph>
          Some cookies are placed by third‑party services we integrate, such as Stripe (payment processing), Google Analytics, and social media buttons. These third parties have their own privacy and cookie policies.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>Your Choices</Typography>
        <Typography variant="body1" paragraph>
          You can control and manage cookies in several ways:
        </Typography>
        <ul>
          <li><Typography variant="body1">Browser settings: Most browsers allow you to block or delete cookies. Please consult your browser's help documentation.</Typography></li>
          <li><Typography variant="body1">Opt‑out tools: For analytics cookies, you can install the Google Analytics opt‑out browser add‑on.</Typography></li>
          <li><Typography variant="body1">Cookie banner: When you first visit our site, you may accept or decline non‑essential cookies.</Typography></li>
        </ul>
        <Typography variant="body1" paragraph>
          Please note that disabling essential cookies may affect the functionality of the platform.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>Changes to this Policy</Typography>
        <Typography variant="body1" paragraph>
          We may update this Cookies Policy from time to time. Any changes will be posted on this page with an updated revision date.
        </Typography>

        <Typography variant="body2" sx={{ mt: 4, color: 'text.secondary' }}>
          For any questions, contact us at privacy@rengigs.com.
        </Typography>
      </Paper>
    </Container>
  );
};

export default CookiesPage;